import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { SiteProvider } from "@/context/SiteContext";
import BookingModal from "@/components/BookingModal";
import AuthCallback from "@/components/AuthCallback";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Cookies from "@/pages/Cookies";
import Disclaimer from "@/pages/Disclaimer";
import Contact from "@/pages/Contact";
import Faq from "@/pages/Faq";
import StemCellTherapy from "@/pages/StemCellTherapy";

function AppRoutes() {
  const location = useLocation();
  // Process Google OAuth return FIRST (session_id lands in the URL fragment).
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/es/privacidad" element={<Privacy es />} />
        <Route path="/es/terminos" element={<Terms es />} />
        <Route path="/es/preguntas-frecuentes" element={<Faq es />} />
        <Route path="/cookies" element={<Cookies />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/es/cookies" element={<Cookies es />} />
        <Route path="/es/aviso-medico" element={<Disclaimer es />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/es/contacto" element={<Contact es />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/stem-cell-therapy" element={<StemCellTherapy />} />
        <Route path="/es/terapia-con-celulas-madre" element={<StemCellTherapy es />} />
      </Routes>
      <BookingModal />
    </>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)) });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => { lenis.raf(time); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); window.__lenis = null; };
  }, []);

  return (
    <div className="App">
      <SiteProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </SiteProvider>
    </div>
  );
}

export default App;
